module.exports = __webpack_public_path__ + "img/VPBANK.9e4be5ee.svg";